module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_9016.6d44f3ff.png";